var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"md nav-toggle",class:[_vm.showNav? 'is-active': '']},[_c('a',{attrs:{"title":_vm.$t('site.func.menu')},on:{"click":function($event){$event.preventDefault();return _vm.navToggle($event)}}})])}
var staticRenderFns = []

export { render, staticRenderFns }